<script setup>
import { useSlots } from 'vue';
import { useInvoiceStore } from '@organisms/ubiq-administration/store/invoices';
import { useDataTableStore } from '@stores/useDataTableStore';
import { useAccountStore } from '../store/account';
import { PAY_CLIENT_BILLING_DOCUMENTS_ENDPOINT } from '../../../_00_elements/tools/routes/routes';
import UbiqDataView from '../../../_01_atoms/components/UbiqDataView.vue';
import InvoiceMenu from './menu/InvoiceMenu.vue';
import { trans } from '../../../_00_elements/translation';
import { currency } from '../../../_00_elements/number-formatter';
import CardEmptyTable from '../general/CardEmptyTable.vue';
import InvoiceTypeColumn from './datatable/InvoiceTypeColumn.vue';

defineProps({
  hiddenColumns: {
    type: Array,
    default: () => [],
  },
});

const invoiceStore = useInvoiceStore();
const accountStore = useAccountStore();
const datatableStore = useDataTableStore();

invoiceStore.setInvoices(window.initialState.invoices);
accountStore.setStripeAccountStatus(window.initialState.stripeAccountStatus);

if (!datatableStore.endpoint) {
  datatableStore.setEndpoint(PAY_CLIENT_BILLING_DOCUMENTS_ENDPOINT);
}

const slots = useSlots();
const hasSlot = (slot) => !!slots[slot];
</script>

<template>
  <UbiqDataView>
    <template #list-item="{ item }">
      <div class="dataview__row">
        <div class="dataview__row-informations">
          <div class="dataview-cell-flex">
            <div class="column--bold">
              {{
                item.type === 'invoice'
                  ? currency(item.amount / 100)
                  : currency(item.amount * -1 / 100)
              }}
            </div>
            <div class="status-label" :class="`status-label--${item.status?.toLowerCase()}`">
              {{ trans(`gestion.invoice.status.${item.type}.${item.status?.toLowerCase()}`) }}
            </div>
          </div>
          <div>
            <InvoiceTypeColumn :type="item.type" :recurring="item.recurring" />
          </div>
          <div class="dataview-invoice-number">
            {{ item.invoice_number || '-' }}
          </div>
          <div
            v-if="!hiddenColumns.includes('client')"
            class="dataview-client"
          >
            {{ item.subscription.pay_organization_buyer.client_invoice_data.email }}
          </div>
          <div v-if="!hiddenColumns.includes('seller')">
            {{ item.subscription?.pay_organization_seller?.billing_invoice_data?.email }}
          </div>
        </div>

        <div class="simple-table__column--actions">
          <template v-if="hasSlot('actions')">
            <slot name="actions" :data="item" />
          </template>
          <InvoiceMenu v-else :invoice="item" />
        </div>
      </div>
    </template>
    <template #empty-state>
      <template v-if="hasSlot('empty-state')">
        <slot name="empty-state" />
      </template>
      <template v-else>
        <CardEmptyTable
          logo="ph_coins_blue"
          :title="trans('gestion.invoice.empty.title')"
          :subtitle="trans('gestion.invoice.empty.subtitle')"
        />
      </template>
    </template>
    <template #empty>
      {{ trans('gestion.subscription.step.1.no_result') }}
    </template>
  </UbiqDataView>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.status-label {
  margin-left: 8px;
}
</style>
